<script setup lang="ts">
</script>

<template>
  <div class="article">
    <h1 class="q-mt-none">投稿規約</h1>
    <p>
      この規約（以下「本規約」）は、斜向（以下「当団体」）が提供する配布ワールドをはじめとした各種コンテンツ（以下「配布物」）を利用者が投稿することに関する規約となります。
    </p>
    <p>
      利用者は、投稿において本規約が定める本団体のロゴ（以下「当団体ロゴ」）を利用することができます。
    </p>
    <p>
      当団体ロゴは、配布物利用規約が適用される当団体の配布物です。
    </p>
    <p>
      なお、本規約は、<router-link to="terms-of-use">配布物利用規約</router-link>と一体となって運用します。
    </p>
    <p>
      配布物利用規約及び規約、ガイドライン等の間に矛盾・抵触する規定がある場合には、各種コンテンツの発信に関しては本規約が優先し、その他のケースにおいては配布物利用規約の規定が優先します。
    </p>
    
    <h2>第１条（投稿目的）</h2>
    <p>
      利用者は、次に掲げる目的を有する場合に限り、配布物に関連する投稿することができます。
    </p>
    <ol>
      <li>当団体の配布物を用いて遊んだ体験の共有を目的として投稿する場合</li>
      <li>当団体の配布物の紹介を目的として投稿する場合</li>
      <li>当団体と提携関係にある利用者が、当該提携又はこれに関連する企画等において、当団体の許諾を得た上で投稿する場合</li>
    </ol>

    <h2>第２条（投稿手法）</h2>
    <ol>
      <li>配布物のプレイ映像や画像等を投稿する際に利用する共有サイトは、本団体が適切であると考えるものに限ります（例：YouTube、Twitter等）。</li>
      <li>前項に規定する共有サイトへの投稿であっても、本団体がその内容が不適切であると判断した投稿については、削除することがあります。</li>
      <li>配布物の配布元である本サイトのURL（https://hsmkai.github.io/）を投稿に明示してください。</li>
      <li>プレイ映像の投稿する際には、映像内において当団体ロゴ又は配布物のロゴ（配布物に同梱されている場合に限ります。）を掲げ、配布物の制作元である当団体の紹介を行ってください。</li>
      <li>第３項乃至前項の規定は、動画サイトへの投稿及び動画の配信に適応されるものであり、投稿する際には毎回行うこととします。</li>
    </ol>

    <h2>第３条（禁止事項）</h2>
    <p>
      利用者が投稿する際に、当団体は、利用者に対し、次に掲げる行為を禁止します。
    </p>
    <ol>
      <li>当団体の許諾を得ることなく、前条に定める投稿目的以外に投稿する行為</li>
      <li>配布物を利用して創作した映像や音楽、静止画等を、本団体の許可なく販売する行為</li>
      <li>利用者の創造性が含まれない投稿や配布物のコピーを投稿する行為</li>
      <li>事実に反する、当団体から協賛や提携を受けているようなことを示唆したり、誤信させたりする行為</li>
      <li>当団体のメンバーと同じアイコン、画像（過去に使用していたものを含む。）を使用する行為</li>
      <li>
        次に掲げる内容を含む投稿
        <ul>
          <li>公序良俗に反する投稿</li>
          <li>当団体または第三者の名誉・信用を毀損または不当に差別もしくは誹謗中傷する投稿</li>
          <li>その他、当団体が不適切と判断する内容を含む投稿</li>
        </ul>
      </li>
      <li>
        当団体ロゴに対して、次に掲げる編集・加工等を行ったロゴを利用する行為
        <ul>
          <li>縦横比の変更による変形</li>
          <li>文字のサイズや書体、文字間のスペースの編集</li>
          <li>識別を損なう加工</li>
          <li>回転を伴う加工</li>
          <li>影や3D、グラデーション等の効果を付ける加工</li>
          <li>色の編集</li>
          <li>一部が欠損した表示</li>
          <li>本サイト上で配布していないロゴ</li>
        </ul>
      </li>
      <li>上記の他、当団体が不適切と判断する行為</li>
    </ol>

    <h3 class="q-mb-none">２０２３年５月１５日  施行</h3>

    <q-separator inset class="q-my-lg"/>

    <h1>ロゴのダウンロード</h1>
    <div class="row justify-center">
      <q-card class="q-pa-md" style="width: min(80%, 400px);">
        <q-img src="@/assets/logo/footer_black.svg"/>

        <q-card-actions align="center" class="q-pt-xl">
          <q-btn label="ダウンロード" color="primary" size="1.5rem" href="/download/斜向ロゴ.zip"/>
        </q-card-actions>
      </q-card>      
    </div>
  </div>
</template>